import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Megaphone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const dateFmt = (iso) => {
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return "";
  }
};

export const Announcements = () => {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/messages`);
        setItems(Array.isArray(data) ? data : []);
      } catch {
        setItems([]);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  if (!loaded || items.length === 0) return null;

  return (
    <section
      id="announcements"
      data-testid="announcements-section"
      className="relative border-t border-white/10 bg-[#0a0a0a]"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-20 md:py-28">
        <div className="flex items-end justify-between gap-6 mb-10 md:mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="font-display uppercase leading-none tracking-tight text-5xl md:text-7xl"
          >
            <span className="text-[#e63946]">Latest</span> From The Kitchen
          </motion.h2>
          <Megaphone className="h-8 w-8 md:h-10 md:w-10 text-[#ffb703] shrink-0" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {items.slice(0, 6).map((m, i) => (
            <motion.article
              key={m.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: (i % 2) * 0.08 }}
              data-testid={`announcement-${m.id}`}
              className="group border border-white/10 rounded-md p-6 md:p-8 bg-[#141414] transition-colors duration-300 hover:border-[#ffb703]/60"
            >
              <div className="flex items-baseline justify-between gap-4 mb-3">
                <h3 className="font-display uppercase text-2xl md:text-3xl leading-none tracking-tight text-white group-hover:text-[#e63946] transition-colors">
                  {m.title}
                </h3>
                <span className="font-body uppercase tracking-widest text-[10px] text-[#a8a8a8] shrink-0">
                  {dateFmt(m.created_at)}
                </span>
              </div>
              <p className="font-body text-[#d1d1d1] whitespace-pre-line leading-relaxed">
                {m.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
